import { PhoneProvider } from "@remi/types/phoneProvider";

import { useUserProfile } from "~/contexts/UserProfileContext";

export const useOpenPhoneLine = () => {
  const { user } = useUserProfile();
  return user.person.phones.find((phone) =>
    phone.telecomProviderPhones.some(
      (telecomProviderPhone) => telecomProviderPhone.provider === PhoneProvider.OPEN_PHONE,
    ),
  );
};
